"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyWeightedRdPercentageToExpensesErrorSchema = exports.ApplyWeightedRdPercentageToExpensesErrorCodes = void 0;
const z = __importStar(require("zod"));
const base_error_interface_1 = require("./base-error.interface");
exports.ApplyWeightedRdPercentageToExpensesErrorCodes = {
    INVALID_QUALIFIED_EXPENSES: 'APPLY_WEIGHTED_RD_PERCENTAGE_TO_EXPENSES_INVALID_QUALIFIED_EXPENSES',
    INVALID_QUALIFIED_AMOUNT: 'APPLY_WEIGHTED_RD_PERCENTAGE_TO_EXPENSES_INVALID_QUALIFIED_AMOUNT',
};
exports.ApplyWeightedRdPercentageToExpensesErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
    code: z.enum([
        exports.ApplyWeightedRdPercentageToExpensesErrorCodes.INVALID_QUALIFIED_EXPENSES,
        exports.ApplyWeightedRdPercentageToExpensesErrorCodes.INVALID_QUALIFIED_AMOUNT,
    ]),
    description: z.string().min(1),
});
